import Space from 'Modules/Space';
import { bool, shape } from 'prop-types';
import React from 'react';
import { Segment } from 'semantic-ui-react';
import { genMedicineInstruction } from 'Helpers/utils';
import { CurrencyLabel } from 'Modules/Currency';
import { CURRENCY_SYMBOLS } from 'Constants/commons';

import css from './PrescriptionItem.less';

const PrescriptionItem = ({ medicine, disabled }) => {
  const { quantity, unitPrice, price, uom, currency, ottersgProductId, lifepackProductId } =
    medicine;
  const isMedicineFromStorage = !!ottersgProductId || !!lifepackProductId;
  const instruction = genMedicineInstruction(medicine, isMedicineFromStorage);
  const currencySymbol = CURRENCY_SYMBOLS[currency] || '';

  return (
    <Segment disabled={disabled} style={{ width: '100%' }}>
      <Space size={12} width="100%">
        <Space size={4}>
          <div className={css.title}>{medicine.description}</div>
        </Space>
        <Space direction="horizontal" justify="space-between">
          <div>
            <span className={css.price}>
              {currencySymbol} <CurrencyLabel value={unitPrice} />
            </span>{' '}
            x {quantity} {uom ?? ''}
          </div>
          <span className={css.price}>
            {currencySymbol} <CurrencyLabel value={price} />
          </span>
        </Space>
        <div className={css.desc}>{instruction}</div>
      </Space>
    </Segment>
  );
};

export default PrescriptionItem;

PrescriptionItem.propTypes = {
  medicine: shape({}).isRequired,
  disabled: bool.isRequired,
};
